<template>
  <div class="page">
    <section class="content-section primary">
      <h1>Marmor Kunze - Experte für Naturstein, Quarzstein und Keramik</h1>
    <div class="section-title">
        <div class="section-title-line"></div>
        <h2>UNSER SERVICE</h2>
        <div class="section-title-line"></div>
    </div>
    <div class="container columns">
      <div v-for="info in infoBoxes" :key="info.id" class="info-box column">
        <div class="info-box-icon">
          <div class="info-box-icon-bg stone-grid"></div>
          <i :class="info.icon"></i>
        </div>
         <h4>{{ info.title | uppercase}}</h4>
        <p>{{ info.text}}</p>
      </div>
      </div>
    </section>
    <section class="content-section secondary">
    <div class="section-title">
        <div class="section-title-line"></div>
        <h2>UNSERE LEISTUNGEN</h2>
        <div class="section-title-line"></div>
    </div>
     <div class="container rows">
       <div class="info-tile row" v-for="leistung in leistungen" :key="leistung.id">
         <router-link :to="{name: leistung.link }">
         <div class="info-tile-image"><img :src="leistung.image"></div>
         <div class="info-tile-title">{{ leistung.id}}</div>
         <div class="info-tile-text">{{ leistung.text}}</div>
         </router-link>
       </div>
     </div>
    </section>
    <section class="content-section primary">
    <div class="section-title">
        <div class="section-title-line"></div>
        <h2>HÖCHSTE QUALITÄT VON RENOMMIERTEN HERSTELLERN</h2>
        <div class="section-title-line"></div>
    </div>
    <div class="container">
      <div class="info-text full">Als Fachhändler für Naturstein liegt uns Ihr Vertrauen und die Qualität der von uns angebotenen Naturstein-Produkte besonders am Herzen. Daher beziehen wir unsere Natursteine ausschließlich von renommierten Firmen wie Rossittis, Neolith, Ceasarstone, Cosentino (Silestone), Diresco oder auch Compac.<br><br>Wie der Naturstein aus den verschiedensten Regionen aus der ganzen Welt abgebaut und den Weg in ihr zu Hause findet, zeigt ein FIlm der Firma Rossittis anschaulich:</div>
      <div class="video-responsive">
        <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/ciKHRHspSV0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <div class="info-text full">Mithife der Materialsuche können Sie eine riesige Datenbank durchforsten und finden so den passenden Naturstein, der ihren persönlichen Anforderungen enspricht und der zu Ihnen und Ihrem Anliegen am besten passt.</div>
      <router-link class="info-button" to="material/materialsuche" >ZU UNSERER MATERIALSUCHE</router-link>
      </div>
    </section>
    <section class="content-section primary">
    <div class="section-title">
        <div class="section-title-line"></div>
        <h2>UNSER VERSPRECHEN</h2>
        <div class="section-title-line"></div>
    </div>
    <div class="container">
      <div class="info-image">
          <img src="static/images/steinmetzwappen.png">
        </div>
      <div class="info-text full"><h3>Wenn Erfahrung auf Leidenschaft trifft, entstehen einzigartige Produkte von höchster Qualität!</h3><br> Seit über 50 Jahren ist unsere Passion die Erschaffung individueller und hochwertiger Naturstein-Produkte, die in Bezug auf Design und Langlebigkeit keine Wünsche offenlassen. Als ein alteingesessener Familienbetrieb sind wir so seit Jahrzenten die Adresse in der Region Mönchengladbach und Umgebung für individuelle Natursteinarbeiten.<br><br>Dabei bieten wir Ihnen ein großes Sortiment an Naturstein-Produkten, aber auch zahlreiche Serviceleistungen rund um das Thema Naturstein an.<br><br>Ob Natursteintreppen oder -bodenbeläge, Fensterbänke, Wandverkleidungen, Küchenarbeitsplatten, Tische, Theken, Waschtische oder ganze Bäder aus Naturstein. Bei uns erhalten Sie handgefertigte Natursteinunikate, die jeder Umgebung einen unverkennbaren und eigenen Look geben.<br><br>Unsere Kunden betreuen wir von der ersten Minute an fachkompetent und individuell! Von der Beratung über die Planung und Feinabstimmung bis lang über das Projektende hinaus, stehen wir Ihnen als professioneller Ansprechpartner und Dienstleister im Bereich Naturstein hilfreich zur Seite!<br><br><h3>Das ist unser Versprechen!</h3></div>
      <router-link class="info-button" to="kontakt" >NEHMEN SIE KONTAKT MIT UNS AUF</router-link>
      </div>
    </section>
  </div>
</template>

<script>
import Slider from "../interface/Slider/Slider";

export default {
  name: "Startseite",
  metaInfo: {
    title: 'Experte für Naturstein, Quarzstein und Keramik',
    meta:[
      { vmid: "google-site-verification", name:"google-site-verification", content:"jSJVdpXdKuz-IN-GE4ysLp9tN6kOLFf0i6OdxMsb1EU"},
      { vmid: 'description', name: 'description', content: "Mit über 50 Jahren Erfahrung in der der Natursteinverarbeitungen ist und bleibt es unser Bestreben Produkte in höchster Qualität zu fairen Preisen anzubieten."},
      { vmid: 'keywords', name: 'keywords', content: "Naturstein, Quarzstein, Keramik, Natursteinprodukte, Natursteinverarbeitung, Naturstein Experte, Naturstein Mönchengladbach, Marmor Mönchengladbach"},
      
    ],
    links: [ {rel: 'canonical', href: 'https://www.marmor-kunze.de/'} ]
  },
  data() {
    return {
      leistungen: [
        {
          id: "Küchenarbeitsplatten",
          link: "Küchenarbeitsplatten",
          image: "static/images/tile-image-01.jpg",
          text:
            "Wir haben uns auf die maßgenaue Fertigung von einzigartigen Küchenarbeitsplatten aus Naturstein, Quarzkomposit und Keramik spezialisiert."
        },
        {
          id: "Böden",
           link: "Böden",
          image: "static/images/tile-image-02.jpg",
          text:
            "Natursteinböden spielen in der modernen Innenraumgestaltung eine immer größere Rolle. Durch den Einsatz moderner Techniken können wir die Verwirklichung eines jeden Farb- und Strukturwunsches für Natursteinböden garantieren."
        },
        {
          id: "Treppen",
          link: "Treppen",
          image: "static/images/tile-image-03.jpg",
          text:
            "Natursteintreppen sind zeitlos, pflegeleicht und langlebig! Als Naturstein-Experte beraten und gestalten wir mit Ihnen zusammen Ihre individuelle Natursteintreppe, die sich harmonisch in ihre Wohnumgebung einpasst."
        },
        {
          id: "Waschtische & Bäder",
          link: "Bäder",
          image: "static/images/tile-image-04.jpg",
          text:
            "Naturstein-Waschtische sind der Blickfang in Ihrem Badezimmer. Durch das individuelle Design und die vielfachen Gestaltungsmöglichkeiten des Natursteins entstehen bei uns handgefertigte Unikate, die ihrem Bad einen unverkennbaren Look geben."
        },
        {
          id: "Fensterbänke",
          link: "Fensterbänke",
          image: "static/portfolio/fensterbaenke/fensterbank002.jpg",
          text:
            "Fensterbänke stehen meist nicht im Mittelpunkt, doch das Besondere einer Naturstein Fensterbank ist für jeden deutlich wahrnehmbar. Bei uns erhalten Sie hochwertige Naturstein Fensterbänke nach Maß, die wir genau nach Ihren Vorstellungen anfertigen und verlegen. "
        },
        {
          id: "Tische & Theken",
           link: "TischeTheken",
          image: "static/images/tische_und_theken.jpg",
          text:
            "Tische und Theken aus Naturstein sind zeitlose Klassiker. Ob Esstisch, Couchtisch, Beistelltisch, Terrassentisch oder Thekentisch, bei uns erhalten Sie ihr individuelles Naturstein Unikat."
        },
       {
          id: "Eingangsbereiche",
           link: "Eingangsbereich",
          image: "static/images/tile-image-08.jpg",
          text:
            "Naturstein Treppenaufgänge und Podeste bieten neben allem Komfort auch einen tollen Blickfang und sorgen so für einen positiven ersten Eindruck bei Ihren Besuchern. In unserem Sortiment haben wir eine große Auswahl von Hartgesteinen, die im Außenbereich verwendet werden können."
        },
        {
          id: "Individuelle Produkte",
           link: "IndividuelleProdukte",
          image: "static/portfolio/kamine/kamin01.jpg",
          text:
            "Natürlich fertigen wir auch individuelle Produkte an! Von kleineren Anfertigen wie zum Beispiel Aschenbechern über Blumentöpfe oder Simse bis hin zu Kaminen ist alle möglich!"
        }
      ],
      infoBoxes: [
        {
          id: 0,
          title: "Beratung",
          icon: "fa fa-comments-o",
          link: "",
          text:
            "Bei unserer individuellen und fachkundigen Beratung greifen wir auf über 50 Jahre Erfahrung mit unseren Kunden und der Verarbeitung von Naturstein, Quarzstein und Keramik zurück. Unser oberstes Ziel dabei ist und bleibt es, ihren Wunsch nach exklusiven und individuellen Produkten zu erfüllen. Fragen Sie uns einfach, was wir alles für Sie tun können.  "
        },
        {
          id: 1,
          title: "Planung",
          icon: "fa fa-pencil",
          link: "",
          text:
            "Eine detaillierte Planung ist essentiell! Daher stehen wir ab der ersten Stunde an Ihrer Seite und übernehmen die Planung anhand Ihrer individuellen Wünsche und Bedürfnisse. Die Planungsphase findet immer in enger Abstimmung mit Ihnen statt, wodurch der Grund-Naturstein für ein perfektes Endergebnis gesetzt wird."
        },
        {
          id: 2,
          title: "Fertigung",
          icon: "fa fa-cog",
          link: "",
          text:
            "Bei der Produktion verwenden wir qualitativ hochwertigen und nachhaltigen Naturstein. In unserer Werkstatt wird der Naturstein mit modernsten Fertigungsanlagen bearbeitet, wodurch wir in der Lage sind jede kreative Idee umzusetzen und Ihnen unsere Produkte in höchster Qualität auszuliefern."
        },
        {
          id: 3,
          title: "Betreuung",
          icon: "fa fa-handshake-o",
          link: "",
          text:
            "Unsere oberste Priorität ist Ihre Zufriedenheit! Daher können Sie sich darauf verlassen, dass wir keine Anstrengungen und Mühen scheuen, wenn es um ihr Anliegen geht. Wir betreuen all unsere Kunden auch über das Projektende hinaus und bieten neben umfangreichen Serviceleistungen auch nützliche Pflegetipps für Natursteine. "
        }
      ]
    };
  },
  filters: {
    uppercase: function(value) {
      return value.toUpperCase();
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/Startseite.vue